import { message } from '@whalecloud/fdx';
import { login, changeUserPwd, qryCurrentSecurityRule } from '@/services/api';
import { qryLoginLogs, queryUsersMsg, queryPortalMsg, modifyProfile, currentUser } from '@pages/Profile/services/useMsg';

const handleParams = params => {
  if (!params || JSON.stringify(params) === '{}') return params;
  const newParam = {};
  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value !== '') newParam[key] = value;
  });
  return newParam;
};

export default {
  namespace: 'profileMgr',

  state: {
    logData: {
      list: [],
      pagination: {},
    },
    useMsg: {},
    portalMsg: [],
    isSuccess: undefined,
    resetModal: false,
    securityRule: {},
    userMsg: '',
    currentUserInfo: {},
  },
  effects: {
    *qryLoginLogs({ payload }, { call, put }) {
      const { success, data } = yield call(qryLoginLogs, handleParams(payload));
      if (success) {
        const { list, pageSize, total, pageNum } = data;
        list.map(v => {
          Object.assign(v, { key: `log_${v.logId}` });
          return v;
        });
        yield put({
          type: 'save',
          payload: {
            logData: {
              list,
              pagination: {
                current: pageNum,
                pageSize,
                total,
              },
            },
          },
        });
      }
    },
    *queryUsersMsg({ payload }, { call, put }) {
      const { success, data } = yield call(queryUsersMsg, handleParams(payload));
      if (success) {
        yield put({
          type: 'save',
          payload: {
            useMsg: data,
          },
        });
      }
      return data;
    },
    *queryPortalMsg({ payload }, { call, put }) {
      const { success, data } = yield call(queryPortalMsg, payload.userId);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            portalMsg: data,
          },
        });
      }
    },
    *login({ payload }, { call, put }) {
      const { success, errorMsg, data } = yield call(login, payload);
      if (success) {
        const { isSuccess } = data;
        if (isSuccess && isSuccess === 1) {
          yield put({
            type: 'changeLoginStatus',
            payload: data,
          });
          // tokenCountDown();
        }
      } else throw errorMsg;
    },
    *changeUserPwd({ payload }, { call, put }) {
      const { data } = yield call(changeUserPwd, payload);
      if (data === 'success') {
        message.success('CHANGE_PWD_SUCCESS');
        yield put({
          type: 'closeModal',
        });
        yield put({
          type: 'login',
          payload: {
            username: payload.userCode,
            password: payload.newPwd,
          },
        });
      } else {
        message.error(data.message, 1);
      }
    },
    *qryCurrentSecurityRule({ payload }, { call, put }) {
      const { success, data } = yield call(qryCurrentSecurityRule);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            securityRule: data,
            resetModal: true,
            userMsg: payload,
          },
        });
      }
    },
    *modifyProfile({ payload }, { call }) {
      yield call(modifyProfile, payload);
    },
    *currentUser(_, { call, put }) {
      const { success, data } = yield call(currentUser);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            currentUserInfo: data,
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    changeLoginStatus(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    closeModal(state, { payload }) {
      return {
        ...state,
        ...payload,
        resetModal: false,
      };
    },
  },
};
